import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { hideApiLoader, showApiLoader } from '../../../../redux/tool-webjam/actions';
import { getMyContactGroup, getMyContacts } from '../../../paymentRequest';
import {
    Button,
    Paper,
    ListItemText,
    ListItemButton,
    ListItem,
    List,
    Typography,
    DialogTitle,
    DialogContent,
    DialogActions,
    Dialog,
    Divider
} from '@mui/material';
import PModalFooter from '../helperComponent/PModalFooter';

function GroupDetail(props) {
    const [isNoResult, setNotResult] = useState(false);
    const [open, setOpen] = useState(false);
    const [list, setList] = useState({
        name: '',
        contact: []
    });

    const dispatch = useDispatch();

    const { handleDetailClose, id } = props;

    useEffect(() => {
        if (props.existingEmail != undefined) {
            setList({
                name: props.existingEmail.group_name,
                contact: props.existingEmail.contact_id
            })
            setOpen(true);
        } else {
            fetchData()
        }
    }, [])

    const handleClose = (type) => {
        handleDetailClose(type)
    }

    const fetchData = (data = {}) => {
        dispatch(showApiLoader())
        getMyContactGroup(data, "/" + id)
            .then(res => {
                setOpen(true);
                dispatch(hideApiLoader())
                if (res.status == 1) {
                    let data = res.data.data;
                    setList({
                        name: data.group_name,
                        contact: data.contact_id
                    })
                }
            })
    }

    return (
        <>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                fullWidth={true}
            >
                <DialogTitle id="alert-dialog-title">
                    Group Name: {list.name}
                </DialogTitle>
                <DialogContent>
                    <Paper style={{ maxHeight: 300, overflow: 'auto' }}>
                        <List sx={{ width: '100%', bgcolor: 'background.paper' }}>
                            {list.contact?.length ? list.contact.map((value, i) => {
                                const labelId = `checkbox-list-label-${value.email}`;
                                return (
                                    <><ListItem
                                        key={value.email}
                                        disablePadding
                                    >
                                        <ListItemButton role={undefined} dense>
                                            <ListItemText id={labelId} primary={value.email} />
                                        </ListItemButton>
                                    </ListItem>
                                        {
                                            list.contact.length - 1 > i &&
                                            <Divider></Divider>
                                        }
                                    </>
                                );
                            }) :
                                <>
                                    <ListItem
                                        key={"No_data"}
                                        disablePadding
                                    >
                                        <ListItemText id={"No_data"} primary={"No data found"} />

                                    </ListItem>
                                </>
                            }
                        </List>
                    </Paper>
                </DialogContent>

                <PModalFooter
                    hideSubmit={true}
                    cancel={() => handleClose(false)}
                />
            </Dialog>
        </>
    );
}

export default GroupDetail;
